import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd  } from '@angular/router';

import { DialogComponent } from '../commons/dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';

import { OAuthService } from '../../services/oauth.service';
import { ModuleService } from '../../services/modules.service';
import { GlobalFlagsService } from '../../services/global-flags.service';
import { HeaderService } from '../../services/header.service';
import { StorageService } from '../../services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { RegistrationService } from '../../services/registration.service';
import { Location } from '@angular/common';
import { from } from 'rxjs';
import posthog from 'posthog-js'

import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', '../../styles/css/dashlite.css' /*'./header.component.medium.scss'*/]
})
export class HeaderComponent implements OnInit {

  // private blogsAvailable = false;
  public href: string = "";
  isLogin :boolean;
  isForgotPassword :boolean;
  isMFA :boolean;
  isSSO :boolean;
  isDOBCheck :boolean;
  idHospital2 = null;
  clinicName2 = null;
  showName = false;


  get isBlogsAvailable() {
    return this.moduleService.isBlogAvailable();
  }

  get isLocalResourcesAvailable() {
    return this.moduleService.isLocalResourcesAvailable();
  }

  get isHelpLineAvailable() {
    return this.moduleService.isHelpLineAvailable();
  }

  get formName() {
    return this.globalFlagsService.formName;
  }

  get alerts() {
    return this.globalFlagsService.alerts;
  }

  get userData() {
    return OAuthService.getAccessToken();
  }

  get user() {
    let itemUserName = localStorage.getItem('username');
    if (itemUserName !== undefined) {
      try {
        let itemUserNameJson = JSON.parse(itemUserName);
        return itemUserNameJson;
      }
      catch (Exception) {
        return '';
      }
    }
    return '';
  }

  get imageLogo() {
   //returns default header logo or hospital logo.
    try {
        let hospitalId = JSON.parse(localStorage.getItem('idHospital'));
        if(hospitalId != null){
            return environment.url.adminHome + '/hospitalLogo/' + hospitalId;
        }
        else if (this.headerHospitalId != null) {
          return environment.url.adminHome + '/hospitalLogo/' + this.headerHospitalId;
       }
        else {
          return this.mycareLogo;
        }
    }
    catch (Exception) {
      return '';
    }
  }

  get logoName() {
    try {
      return JSON.parse(localStorage.getItem('clinicName'));
    }
    catch (Exception) {
      return '';
    }
  }

  userLanguage = null;
  isCollapsed = true;
  mainHeader = 'headerBackground.jpg';
  ioNewsHeader = 'headerBackground2.jpg';
  path = null;
  mycareLogo = 'mycareLogo.png';
  logoHospitalName = 'MyCareReport';
  headerHospitalId = null;

  secondaryImgHeader;

  public status: { isopen: boolean } = { isopen: false };

  public toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.status.isopen = !this.status.isopen;
  }

  public change(value: boolean): void {
    this.status.isopen = value;
  }

  constructor(private oAuthService: OAuthService,
    private routerH: ActivatedRoute,
    private route: Router,
	  private registrationService: RegistrationService,
    private globalFlagsService: GlobalFlagsService,
    private moduleService: ModuleService,
    private headerService: HeaderService,
    private storageService: StorageService,
    private dialog: MatDialog,
    private router: Router,
    private translate: TranslateService,
    private location: Location) {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.isLogin = window.location.pathname.includes("/login");
        this.isForgotPassword =  window.location.pathname.includes("/forgotPassword");
        this.isMFA =  window.location.pathname.includes("/mfaLogin");
        this.isSSO =  window.location.pathname.includes("/continueWithSSO");
        this.isDOBCheck= ( window.location.href.includes("/startSurvey?token="));
      }
    });
  }

  ngOnInit() {

    this.isLogin = window.location.pathname.includes("/login");
    this.isForgotPassword =  window.location.pathname.includes("/forgotPassword");
    this.isMFA =  window.location.pathname.includes("/mfaLogin");
    this.isSSO =  window.location.pathname.includes("/continueWithSSO");
    this.isDOBCheck= ( window.location.href.includes("/startSurvey?token="));




    this.routerH.queryParams.subscribe(params => {
      let token = params['token'];
      const obj = {
        'token': token
      };


      this.headerHospitalId = params['idHospital'];
      if(obj.token !== undefined){
        this.validateToken(obj);
      }
       });

    if (OAuthService.getAccessToken() && !this.location.path().includes('/startSurvey') && !this.location.path().includes('/logout') ) {
      const header = from(this.headerService.getHeader());
      header
        .subscribe(
        (res) => {
          this.storageService.setUsername(res.userFirstName);
          this.storageService.setShowName(res.showName);
          this.idHospital2 = res.idHospital;
          this.clinicName2 = res.clinic;
          this.showName = res.showName;
          OAuthService.saveAppModules(res.appModules);
          OAuthService.saveLanguage(res.lang);
          OAuthService.saveLanguageCode(res.langCode);
          this.translate.use(res.langCode);
        },
        err => {
          const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
          const data = { message: `${errMsg}. Please try again.` };
          //this.dialog.open(DialogComponent, { data });
          //this.router.navigate(['/error']);
          //throw err;
        }
        );
    }

  }

  validateToken(obj : any) {
    const confirmation = from(this.registrationService.checkIsValidTokenInstance(obj));
    confirmation
      .subscribe((res: any) => {
        if (res != null) {
          this.idHospital2 = res.idHospital;
          this.clinicName2 = res.clinicName
          this.showName = res.showName;
        }
      });
  }

  logout() {
    this.status.isopen = false;
    this.globalFlagsService.cleanAlerts();
    const tokenT = from(this.registrationService.revokeToken({tokenId:this.userData}));
    tokenT
    .subscribe((res: any) => {
        if (res != null) {
          this.oAuthService.logout(null, true);
          if(this.globalFlagsService.isPosthogEnabled){
            posthog.reset();
          }
          this.route.navigate(['login']);
      }

    }
    );
  }

  isDashboardRoute() {
    return this.route.url === '/' || this.route.url.includes('?fromLogin');
  }

  getRouteUrl () {
    return this.route.url;
  }
}
